<template>
    <div class="container">
        <div class="columns">
            <div class="column is-10">
                <header class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <div class="control">
                                <button class="button is-info">This Week</button>
                            </div>
                        </div>
                        <div class="level-item">
                            <div class="control">
                                <button class="button is-info">This Month</button>
                            </div>
                        </div>
                        <div class="level-item">
                            <div class="control">
                                <button class="button is-info">This Year</button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <label class="heading is-size-3"></label>
                    </div>
                    <div class="level-right">
                        <div class="field has-addons">
                            <datepicker v-model="searchDate" :config="{wrap:true}"></datepicker>
                            <div class="control">
                                <button class="button   is-success">
                                    <font-awesome-icon icon="search" size=""/>
                                </button>
                            </div>
                        </div>
                    </div>
                </header>

                <line-charts></line-charts>
            </div>
            <div class="authorization columns is-2">

                <article class="message">
                    <div class="message-header">
                        <p class="heading is-size-4 has-text-weight-bold has-text-centered">Authorization</p>

                    </div>
                    <div class="message-body">
                        <div>
                            <ul>
                                <li class="box heading has-text-weight-bold has-text-centered is-size-5 "
                                    onclick="alert('denem')"
                                    style="background-color: #3298dc">Schedule
                                </li>
                                <li class="box heading has-text-weight-bold has-text-centered is-size-5"
                                    onclick="alert('denem')"
                                    style="background-color: #3298dc">Flights
                                </li>
                                <li class="box heading has-text-weight-bold has-text-centered is-size-5"
                                    onclick="alert('denem')"
                                    style="background-color: red">Services
                                </li>
                                <li class="box heading has-text-weight-bold has-text-centered is-size-5"
                                    onclick="alert('denem')"
                                    style="background-color: red">Efb
                                </li>
                                <li class="box heading has-text-weight-bold has-text-centered is-size-5"
                                    onclick="alert('denem')"
                                    style="background-color: red">Admin
                                </li>
                                <li class="box heading has-text-weight-bold has-text-centered is-size-5"
                                    onclick="alert('denem')"
                                    style="background-color: red">Users
                                </li>
                                <li class="box heading has-text-weight-bold has-text-centered is-size-5"
                                    onclick="alert('denem')"
                                    style="background-color: yellow">Aircraft
                                </li>
                            </ul>
                        </div>
                    </div>
                </article>


            </div>
        </div>

    </div>
</template>

<script>
    import EffLineCharts from "../components/Charts/EffLineCharts";
    import Datepicker from 'vue-bulma-datepicker'


    export default {
        name: "UnderConstruction",
        components: {
            LineCharts: EffLineCharts,
            Datepicker
        },
        data() {
            return {
                datacollection: null,
                searchDate: null,
                searchText: null
            }
        },
    }
</script>

<style scoped>
    .box {
        width: 300px;
        height: 80px;
        margin: 20px;
        cursor: pointer;
    }

    .authorization {
        margin: 10px;
        border: solid 1px #e4e4e4;
        box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02)
    }

    .authorization-heading {
        height: 50px;
        text-align: center;
        margin: 10px;
        border: 1px solid #ababab;
        background-color: #ababab;
    }
</style>
